import LeadFinderSubscriptionPlan from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";

export const LEAD_FINDER_MAX_SEARCHES = 5;

// Plans allowed to run the "get more results in this area" refresh search.
export const LEAD_FINDER_PLANS_SUPPORTING_MORE_RESULTS = [
  LeadFinderSubscriptionPlan.PRO,
  LeadFinderSubscriptionPlan.STARTER,
  LeadFinderSubscriptionPlan.ADVANCED,
  LeadFinderSubscriptionPlan.ELITE,
];

export const LEAD_FINDER_QUERY_LIMIT_FIRST = 60;
export const LEAD_FINDER_QUERY_LIMIT_FOLLOWING = 20;

export const LEAD_FINDER_DISTANCES_KM = [1, 10, 25, 50];
export const LEAD_FINDER_DISTANCES_MILES = [1, 5, 10, 30];
export const LEAD_FINDER_CUSTOM_DISTANCES_MAX = 10;
export const LEAD_FINDER_DEFAULT_DISTANCE_KM = 50;
export const LEAD_FINDER_DEFAULT_DISTANCE_MILES = 30;
